//import react polyfill
import React from 'react';
import { createRoot } from 'react-dom/client';

import config from './constants/Configs'

//Import App Components
import './index.css';
import App from './App';
import './services/AxiosMiddleware';

//Sentry integration
// import './services/sentry';

// Import Ant Design 5 reset CSS (Antd 5 uses CSS-in-JS, but reset.css provides base styles)
// Note: Antd 5 no longer needs the full CSS import - components use CSS-in-JS
import "antd/dist/reset.css";

// TODO need to figure out why we need this file (there are some global styles and antd overrides)
// import "./assets/less/ant.css";

//Import styles
import './assets/styles/main.css';

import { Provider } from 'react-redux'

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import configureStore from './services/ConfigureStore'
import { exchangeLaunchToken } from './actions/account/VerificationActions';
import { LocalStorageService } from './services/LocalStorageService';

//Initial state
import { initialState } from './constants/InitialState';

// Configure Redux store
const store = configureStore(initialState)

store.subscribe(() => {
  //localStorage.setItem('saved_store_state', JSON.stringify(store.getState()));
});

export default store;

// Create React root once
const target = document.querySelector('#root');
const root = createRoot(target);

// App wrapper with providers
const AppWrapper = () => (
  <Provider store={store}>
      <App />
  </Provider>
);

// Create the router with the App component
const router = createBrowserRouter([
  {
    path: '*',
    element: <AppWrapper />
  }
]);

// Handle bookmarklet redirect: ?data=<authorizationData>&from=<staging-url>
function handleBookmarkletRedirect() {
  const params = new URLSearchParams(window.location.search);
  const incoming = params.get('data');
  if (process.env.NODE_ENV !== 'development' || !incoming) return false;
  try {
    const parsed = JSON.parse(decodeURIComponent(incoming));
    if (!parsed.access_token) return false;
    localStorage.setItem('authorizationData', JSON.stringify(parsed));
    const from = params.get('from');
    let redirect = '/edit/customize/100?cid=2&p=100';
    if (from) {
      try {
        const u = new URL(decodeURIComponent(from));
        redirect = u.pathname + u.search;
      } catch {}
    }
    window.location.replace(redirect);
    return true;
  } catch {
    return false;
  }
}

async function handleQueryTokenLogin() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  if (!code) return;

  try {
    const authData = await store.dispatch(exchangeLaunchToken(code));
    if (authData && authData.access_token) {
      LocalStorageService.set('authorizationData', authData);
    }
  } catch (error) {
    console.error('Login via query token failed:', error);
  } finally {
    params.delete('code');
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash || ''}`;
    window.history.replaceState({}, '', nextUrl);
  }
}

async function bootstrapApp() {
  const redirectedByBookmarklet = handleBookmarkletRedirect();
  if (redirectedByBookmarklet) return;

  await handleQueryTokenLogin();

  // IF SSO IS NOT ENABLED CASE
  root.render(<RouterProvider router={router} />);
}

bootstrapApp();
